import type { SortDirection } from './types';

export const SELECTABLE_COLUMN_STICKY_INDEX = -1;
export const TOTAL_CHECKED_INDEX = -1;
export const CHECKBOX_COL_WIDTH = 56;
export const DEFAULT_SORTING_ORDER: SortDirection[] = [
  'ascending',
  'descending',
  null
];
